export default __webpack_public_path__ + "static/media/bg-onb.58d06a5f.svg";